"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entityReverseFieldQuery = void 0;
var client_1 = require("@apollo/client");
var graphql_1 = require("./graphql");
var entityReverseFieldQuery = function (definition, reverseFields) {
  var q = (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query ", "ReverseFieldQuery($id: ID!) {\n      ", "(id: $id) {\n        id\n        slug\n        name\n        ...EntityValueFields\n        ", "\n      }\n    }\n  "], ["\n    query ", "ReverseFieldQuery($id: ID!) {\n      ", "(id: $id) {\n        id\n        slug\n        name\n        ...EntityValueFields\n        ", "\n      }\n    }\n  "])), definition.typeName, definition.updateTypeName, reverseFields || '');
  return (0, client_1.gql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), q);
};
exports.entityReverseFieldQuery = entityReverseFieldQuery;
var templateObject_1, templateObject_2;